export const timeWithSecond = 'HH:mm:ss';
